module.exports = __webpack_public_path__ + "img/memory_24.7698d790.jpg";